import { ChatBotPage } from '@/Chat/ChatBotPage'
import { InedxPage } from '@/Index/inedx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ChatBotPage />
}
